import React, { useState } from 'react'
import { useAppDispatch } from '../../../../hooks/reduxHooks'
import { changeDesktopPage } from '../../../../redux/slices/DesktopSlice/DesktopSlice'
import styles from './AppMenu.module.scss'

const AppMenu = () => {
  const dispatch = useAppDispatch()
  const [closeMenu, setcloseMenu] = useState(false)

  const handleClickOutside = (event: React.MouseEvent) => {
    event.preventDefault()
    setcloseMenu(true)
  }

  return (
    <div
      className={`${styles.appMenu} ${closeMenu ? styles.closeMenu : ''}`}
      onClick={handleClickOutside}
      onAnimationEnd={() => {
        if (closeMenu) dispatch(changeDesktopPage(''))
      }}
    >
      <div className={styles.appContainer} />
    </div>
  )
}

export default AppMenu
